import { useEffect, useReducer } from 'react';

interface AnimationState {
	shouldRender: boolean;
	isClosing: boolean;
}

type AnimationAction =
	| { type: 'OPEN' }
	| { type: 'START_CLOSE' }
	| { type: 'FINISH_CLOSE' };

const reducer = (
	state: AnimationState,
	action: AnimationAction,
): AnimationState => {
	switch (action.type) {
		case 'OPEN':
			return { shouldRender: true, isClosing: false };
		case 'START_CLOSE':
			return { shouldRender: true, isClosing: true };
		case 'FINISH_CLOSE':
			return { shouldRender: false, isClosing: false };
		default:
			return state;
	}
};

const ANIMATION_DURATION = 250;

export const useExitAnimation = (
	isOpen: boolean,
): { shouldRender: boolean; isClosing: boolean } => {
	const [state, dispatch] = useReducer(reducer, {
		shouldRender: isOpen,
		isClosing: false,
	});

	useEffect(() => {
		if (isOpen) {
			dispatch({ type: 'OPEN' });
		} else if (state.shouldRender) {
			dispatch({ type: 'START_CLOSE' });
			const timer = setTimeout(() => {
				dispatch({ type: 'FINISH_CLOSE' });
			}, ANIMATION_DURATION);
			return () => clearTimeout(timer);
		}
	}, [isOpen, state.shouldRender]);

	return state;
};
